import { combineReducers } from 'redux'

import menuDataReducer from './menu-data-reducer'

export default combineReducers({
  menuData: menuDataReducer,
})
